/**
 * portal-content.js v3
 * - Switcher produits (niveau 1)
 * - Accordéons pour chaque item de contenu
 * Placer dans /assets/
 */

(function () {
  'use strict';

  /* ══════════════════════════════════════
     SWITCHER PRODUITS
  ══════════════════════════════════════ */
  function initProductSwitcher() {
    const tabs   = document.querySelectorAll('.portal-switcher__tab');
    const groups = document.querySelectorAll('.portal-group');
    
    if (!tabs.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-target');

        // Trouver le groupe actuellement actif
        const currentGroup = document.querySelector('.portal-group.is-active');
        const nextGroup = document.getElementById(target);

        // Si on clique sur le tab déjà actif, rien faire
        if (currentGroup === nextGroup) return;

        // Mettre à jour les tabs immédiatement
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        // FadeOut du groupe actif, puis fadeIn du suivant
        if (currentGroup) {
          currentGroup.classList.add('is-leaving');
          setTimeout(() => {
            currentGroup.classList.remove('is-active', 'is-leaving');
            if (nextGroup) nextGroup.classList.add('is-active');
          }, 300); // durée du fadeOut
        } else {
          if (nextGroup) nextGroup.classList.add('is-active');
        }
      });
    });
  }

  /* ══════════════════════════════════════
     ACCORDÉONS
     Compatible avec les attributs data-accordions
     de ton thème existant.
  ══════════════════════════════════════ */
  function initAccordions() {
    // Cherche tous les conteneurs d'accordéons
    document.querySelectorAll('[data-module-accordions]').forEach(list => {
      list.querySelectorAll('[data-accordions="toggler"]').forEach(toggler => {
        toggler.addEventListener('click', () => {
          const item    = toggler.closest('.c-accordions_list_item');
          const content = item.querySelector('[data-accordions="content"]');
          const isOpen  = item.classList.contains('is-open');

          // Fermer tous les autres du même groupe
          const siblings = toggler.closest('[data-module-accordions]')
            .querySelectorAll('.c-accordions_list_item');
          siblings.forEach(sib => {
            if (sib !== item) {
              sib.classList.remove('is-open');
              const sibContent = sib.querySelector('[data-accordions="content"]');
              const sibToggler = sib.querySelector('[data-accordions="toggler"]');
              if (sibContent) sibContent.classList.remove('is-open');
              if (sibToggler) sibToggler.setAttribute('aria-expanded', 'false');
            }
          });

          // Toggle cet item
          item.classList.toggle('is-open', !isOpen);
          if (content) content.classList.toggle('is-open', !isOpen);
          toggler.setAttribute('aria-expanded', String(!isOpen));

          // Stopper la vidéo si on ferme
          if (isOpen) {
            const iframe = content?.querySelector('iframe');
            if (iframe) {
              const src = iframe.src;
              iframe.src = '';
              setTimeout(() => { iframe.src = src; }, 50);
            }
          }
        });

        // Init ARIA
        toggler.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', () => {
    initProductSwitcher();
    initAccordions();
  });



  /* ═══════════════════════════════════════════════════════
     FAQ VISIBILITY SYNC
     Hides FAQ sections whose data-faq-product does not match
     the currently active product-group tab. Shows a placeholder
     section (data-faq-product="placeholder") only when no
     other FAQ matches the active product.
  ═══════════════════════════════════════════════════════ */
  function getActiveProductId() {
    const activeTab = document.querySelector('.portal-switcher__tab.is-active');
    return activeTab ? activeTab.getAttribute('data-target') : null;
  }

  function syncFaqVisibility() {
    const activeProduct = getActiveProductId();
    if (!activeProduct) return;
    const faqSections = document.querySelectorAll('[data-faq-product]');
    let visibleCount = 0;
    let placeholderShell = null;
    faqSections.forEach(el => {
      const wrap = el.closest('.shopify-section');
      if (!wrap) return;
      const product = el.getAttribute('data-faq-product');
      if (product === 'placeholder') {
        placeholderShell = wrap;
        return;
      }
      const matches = product === activeProduct;
      wrap.style.display = matches ? '' : 'none';
      if (matches) visibleCount++;
    });
    if (placeholderShell) {
      placeholderShell.style.display = visibleCount === 0 ? '' : 'none';
    }
  }

  function initFaqSync() {
    // Initial sync on load
    syncFaqVisibility();
    // Re-sync after each tab click (runs after the 300ms group transition)
    const tabs = document.querySelectorAll('.portal-switcher__tab');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Run after the activeTab class flip which happens synchronously in switcher
        setTimeout(syncFaqVisibility, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqSync);
  } else {
    initFaqSync();
  }

})();
